import { mapActions, mapGetters } from "vuex";
import * as types from "@/store/types";
import { UserService } from "@/services";
import vueAwesomeCountdown from "vue-awesome-countdown";

export default {
  name: "otp setting",
  components: { vueAwesomeCountdown },
  props: [],
  data() {
    return {
      twoFactorId: 1,
      activationType: "",
      inactiveModal: false,
      inactivePassword: "",
      showInactivePassword: false,
      activeModal: false,
      activePassword: "",
      activeCode: "",
      showActivePassword: false,
      ttl: 0,
      previousOtpState: "",
      otpTypes: [],
      activeType: null
    };
  },
  computed: {
    ...mapGetters({
      userVerifyInfo: types.userVerifyInfo.getters.GET_USER_VERIFY_INFO,
      userInfo: types.userInfo.getters.GET_USER_INFO
    }),
    isMobileVerified() {
      return this.userVerifyInfo.is_mobile_verified;
    }
  },
  mounted() {
    this.getOtpType();
  },
  methods: {
    ...mapActions({
      setShow2FA: types.account.actions.SET_SHOW_2FA,
      setOtpSetting: types.account.actions.SET_SHOW_OTP_SETTING,
      setUserData: types.userInfo.actions.ACTION_USER_INFO
    }),
    getOtpType() {
      UserService.getOtpType().then(res => {
        this.otpTypes = res.data.data.available_otp_types;
        this.activeType = res.data.data.current_user_otp_type;
      });
    },
    getUserInfo() {
      UserService.getInfo().then(response => {
        this.setUserData(response.data.data);
      });
    },
    hideSection() {
      this.setOtpSetting(false);
    },
    changeOtpType(id) {
      let model = {
        type: id
      };
      UserService.changeOtpType(model).then(response => {
        this.$toast.success(response.data.message);
      });
    }
  }
};
